/// <reference types="@angular/localize" />

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserUtils } from '@azure/msal-browser';

// Moment.js Japanese locale for datepicker
import moment from 'moment';
import 'moment/locale/ja';
moment.locale('ja');

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function () {};
  }
}

// Skip bootstrap inside MSAL silent-token iframes (and popups).
// MSAL navigates a hidden iframe to the redirectUri to capture the OAuth
// response in the URL hash; the parent reads the iframe's location.hash
// directly (same-origin) and does not need the iframe to do anything.
// Without this guard the app bootstraps inside the iframe and re-runs every
// APP_INITIALIZER + guard + data fetch, which doubles all API calls on every
// silent token acquisition — visible in the trace as paired requests with
// identical client-request-id.
if (BrowserUtils.isInIframe() || BrowserUtils.isInPopup()) {
  // Intentionally no-op. MSAL handles the response via the parent window.
} else {
  bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
}
